import { CreditCardPaymentForm } from './CreditCardPaymentForm';

type CreditCardPaymentFormContainerProps = {
  goToStep: (step: string) => void;
  onPrev: () => void;
};

export const CreditCardPaymentFormContainer = ({
  goToStep,
  onPrev,
}: CreditCardPaymentFormContainerProps) => {
  return <CreditCardPaymentForm goToStep={goToStep} onPrev={onPrev} />;
};
